import styles from "../css/about.module.css";
import copy from "../media/copy.png";
import profile from "../media/profile.png";

export const About = () => {
  return (
    <>
      <div id="about" className={styles.container}>
        <div>
          <h1 className={styles.heading}>All About Me</h1>
        </div>
        <div className={styles.pic}>
          <img src={profile} alt="profile_img" />

          <div>
            <h2 className={styles.heading2}>I am Vinayak Hiwse</h2>
            <div className={styles.para}>
              A web developer with a vast array of knowledge in many different
              front end and backend languages, responsive frameworks, databases,
              and best code practices. Look forward to using my skills for
              gaining more experience.
            </div>
            <div className={styles.mail}>
              Drop a mail vinayakhiwse8@gmail.com{" "}
              <span
                onClick={() => {
                  navigator.clipboard.writeText("vinayakhiwse8@gmail.com");
                }}
              >
                <img src={copy} alt="" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.slide}>
        <div className={styles.slide1}>
          1200+ hrs <br /> Coding
        </div>
        <div className={styles.slide1}>
          600+ hrs <br /> DSA
        </div>
        <div className={styles.slide1}>
          100+ hrs <br /> Soft Skills
        </div>
        <div className={styles.slide1}>
          550+ Git <br /> Commits
        </div>
        <div>
          5+ <br /> Collaborative Projects
        </div>
        <div>
          50+ <br /> Individual Projects
        </div>
      </div>
    </>
  );
};
